<div class="widget-framework">
  <jafar-page-widget [contents]="contentTemplate" [actions]="actionTemplate" >
      <div title>Requests</div>
      <div subtitle> View List of CIP Requests  </div>
  </jafar-page-widget>
</div>

<ng-template #contentTemplate >
  View a List of CIP Requests.<br> You also have the ability to Search for a Requests by: <br> <b>CIP Id</b> or <b>Request Id</b><br>
</ng-template>

<ng-template #actionTemplate>
  <button mat-flat-button matTooltip="Manage Customers" (click)="buttonClicked()" class="manage-azure-button">
      Go To Requests
      <mat-icon>shortcut</mat-icon>
  </button>
</ng-template>